import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import { useFormik } from "formik";
import * as Yup from "yup";
import { request } from "../../config/request.ts";
import { toast } from "react-toastify";
import PageHeader from "../../shared/PageHeader/index.tsx";
import TextField from "../../shared/TextField/index.tsx";
import SelectField from "../../shared/SelectField/index.tsx";
import PageWrapper from "../../shared/PageWrapper/index.tsx";
import "../../styles/scss/Form.scss";

export default function ContactConfigurationCreateEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const isEdit = id && id !== "new";

  const formik = useFormik({
    initialValues: {
      key: "",
      value: "",
      isActive: "Active",
    },
    validationSchema: Yup.object({
      key: Yup.string().required("Key is required"),
      value: Yup.string().required("Value is required"),
    }),
    onSubmit: async (values) => {
      const payload = {
        key: values.key,
        value: values.value,
        status: values.isActive === "Active",
      };

      try {
        let response;
        if (isEdit) {
          response = await request.put("contact-configurations/" + id, payload);
        } else {
          response = await request.post("contact-configurations/create", payload);
        }

        if (response?.data?.status) {
          toast.success(
            isEdit ? "Configuration updated successfully!" : "Configuration created successfully!",
          );
          navigate("/admin/contact-configuration");
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "An error occurred. Please try again.");
      }
    },
  });

  useEffect(() => {
    if (isEdit) {
      const fetchItem = async () => {
        setLoading(true);
        try {
          const response = await request.get(`contact-configurations/${id}`);
          const item = response.data.data;
          formik.setValues({
            key: item.key || "",
            value: item.value || "",
            isActive: item.status ? "Active" : "Inactive",
          });
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      };

      fetchItem();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <PageWrapper loading={loading}>
      <Box className="form-container">
        <Box className="form-page">
          <Box className="form-header">
            <PageHeader
              title={isEdit ? "Edit Configuration" : "Create New Configuration"}
              secondaryButton={{
                label: "Cancel",
                onClick: () => navigate("/admin/contact-configuration"),
              }}
              primaryButton={{
                label: isEdit ? "Update Configuration" : "Create Configuration",
                icon: <span className="material-symbols-outlined">save</span>,
                onClick: () => formik.handleSubmit(),
              }}
            />
          </Box>

          <Box className="form-card">
            <Box className="form-card-body">
              <Box className="form-grid form-grid--2">
                <Box className="form-field">
                  <TextField name="key" label="Key" type="text" formik={formik} autoFocus placeholder="e.g. contact_email" />
                </Box>
                <Box className="form-field">
                  <TextField name="value" label="Value" type="text" formik={formik} />
                </Box>
              </Box>

              <Box className="form-grid form-grid--2" style={{ marginTop: "16px" }}>
                <Box className="form-field">
                  <SelectField
                    name="isActive"
                    label="Status"
                    formik={formik}
                    options={[
                      { value: "Active", label: "Active" },
                      { value: "Inactive", label: "Inactive" },
                    ]}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </PageWrapper>
  );
}